import {
  detectLanguage,
  T,
  TolgeeProvider,
  useTolgee,
  useTranslate,
} from "@tolgee/react";
import { tolgee } from "./client";
import { getLanguage, setLanguage } from "./language";

const t = tolgee.t;

export {
  useTranslate,
  T,
  t,
  tolgee,
  useTolgee,
  getLanguage,
  setLanguage,
  TolgeeProvider,
  detectLanguage,
};
